import React from 'react'
import SharedPlanConfirmationForm from '../../products/forms/PlanConfirmationForm'
import {
  sortedPlanTypeOptions,
  planTypeValues,
  sortedPlanStatusOptions,
  planStatusValues,
} from 'config/automatic-rollovers'
import FlowActions from '../components/FlowActions'

const planTypeConfig = {
  options: sortedPlanTypeOptions,
  values: planTypeValues,
}
const planStatusConfig = {
  options: sortedPlanStatusOptions,
  values: planStatusValues,
}

const PlanConfirmationForm = React.forwardRef(function PlanConfirmationForm(
  props,
  ref
) {
  return (
    <SharedPlanConfirmationForm
      {...props}
      ref={ref}
      planTypeConfig={planTypeConfig}
      planStatusConfig={planStatusConfig}
      FlowActionsComponent={FlowActions}
    />
  )
})

export default React.memo(PlanConfirmationForm)
